var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "footer",
      style: _vm.supressPadding && {
        padding: 0,
        marginBottom: _vm.bottomPadding ? "60px" : ""
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "separator" }),
      _vm._v(" "),
      _c("div", { staticClass: "disclaimer" }, [
        _vm._v(
          "\n    Lili is a financial technology company, not a bank.\n    Banking services provided by Sunrise Banks, N.A., Member FDIC.\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Lili Customer Service")]),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          { attrs: { href: "mailto:support@lili.co", target: "_blank" } },
          [_vm._v("Email our support team")]
        ),
        _vm._v(" or call us")
      ]),
      _vm._v(" "),
      _c("div", [_vm._v("(855) 545-4380")]),
      _vm._v(" "),
      _c("div", [_vm._v("9:00am-7:00pm EST Monday - Friday")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4080ae5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4080ae5f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalUiComponents/MobileFooter.vue
// module id = null
// module chunks = 